// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../order-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bubble-container[data-v-55cdf53a]{margin:5px;padding:0;text-align:center}", ""]);
// Exports
module.exports = exports;
